const PATH = 'fe.components.password';

const messages = {
  changePassword: {
    key: `${PATH}.change_password`,
    defaultValue: 'Change Password'
  },
  confirmPassword: {
    key: `${PATH}.confirm_password`,
    defaultValue: 'Confirm Password'
  },
  clear: {
    key: `${PATH}.clear`,
    defaultValue: 'Clear'
  },
  savePassword: {
    key: `${PATH}.save_password`,
    defaultValue: 'Save Password'
  },
  saving: {
    key: `${PATH}.saving`,
    defaultValue: 'Saving...'
  },
  lengthMin: {
    key: `${PATH}.length_min`,
    defaultValue: 'At least 12 characters'
  },
  lengthMax: {
    key: `${PATH}.length_max`,
    defaultValue: 'Fewer than 64 characters'
  },
  noFirstName: {
    key: `${PATH}.no_first_name`,
    defaultValue: 'Must not contain first name'
  },
  noLastName: {
    key: `${PATH}.no_last_name`,
    defaultValue: 'Must not contain last name'
  },
  noEmail: {
    key: `${PATH}.no_email`,
    defaultValue: 'Must not contain any part of your email'
  },
  match: {
    key: `${PATH}.match`,
    defaultValue: 'Passwords must match'
  },
  passwordNotAccepted: {
    key: `${PATH}.password_not_accepted`,
    defaultValue:
      'That password cannot be used. Please choose a different one that meets the requirements shown.'
  },
  requirementsNotMet: {
    key: `${PATH}.requirements_not_met_hint`,
    defaultValue:
      'This password does not meet the requirements. Make sure you are not including your first name, last name, or email in the password.'
  },
  commonPassword: {
    key: `${PATH}.common_password`,
    defaultValue:
      'This password uses a common word that is easy to guess. Please choose a different password.'
  },
  recentlyUsedPassword: {
    key: `${PATH}.recently_used_password`,
    defaultValue:
      'This password was used recently. Please choose a password you have not used before.'
  },
  passwordDoesNotMeet: {
    key: `${PATH}.password_does_not_meet`,
    defaultValue: 'Password does not meet requirements'
  },
  passwordRequirementsNotMet: {
    key: `${PATH}.password_requirements_not_met`,
    defaultValue: 'Password does not meet the following requirements:'
  },
  pleaseConfirm: {
    key: `${PATH}.please_confirm`,
    defaultValue: 'Please confirm your password'
  },
  passwordsDoNotMatch: {
    key: `${PATH}.passwords_do_not_match`,
    defaultValue: 'Passwords do not match'
  },
  passwordRequirementsHeading: {
    key: `${PATH}.password_requirements_heading`,
    defaultValue: 'Password requirements'
  },
  showPassword: {
    key: `${PATH}.show_password`,
    defaultValue: 'Show password'
  },
  hidePassword: {
    key: `${PATH}.hide_password`,
    defaultValue: 'Hide password'
  },
  showConfirmPassword: {
    key: `${PATH}.show_confirm_password`,
    defaultValue: 'Show confirm password'
  },
  hideConfirmPassword: {
    key: `${PATH}.hide_confirm_password`,
    defaultValue: 'Hide confirm password'
  }
};

export default messages;
